import '../left-menu';
import '../side-panel';

export default (ctx, html) => html`
  <div class="overlay ${ctx.showOverlay ? 'active' : ''}"></div>
  <side-panel>
    <left-menu></left-menu>
  </side-panel>
`;
